// Espelha o lookup `venda_tipo_bloqueio` (db_vendas) e o VendaTipoBloqueioEnum das APIs — os
// motivos de bloqueio que a liberação presencial (story §6.5) pode destravar.
export enum VendaTipoBloqueioEnum {
    Desconto = 1,
    OrcamentoVencido = 2,
    LimiteDeCredito = 3,
    TituloEmAtraso = 4,
    PrecoAbaixoDoMinimo = 5,
    DivergenciaDocumentoOrigem = 6,
    RemocaoDeItem = 7,
}
